// extracted by mini-css-extract-plugin
module.exports = {"el":"Link_el__1gGic"};